var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-time-filter flex-row"},[_c('date-time-input',{model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}}),_vm._v("  –  "),_c('date-time-input',{model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }